<template>
  <span :class="['search-title', labelClass]">{{ label }}</span>
  <ul class="search-rdo-box">
    <li v-for="month in [1, 3, 6, 12]" :key="month" class="search-rdo">
      <input type="radio" name="searchRdo" :id="'searchRdo' + month" :value="month" v-model="selectedMonth" @change="setRange(month)" />
      <label :for="'searchRdo' + month">{{ month }}개월</label>
    </li>
  </ul>
  <div :class="['datepicker-wrap', datePickerClass]">
    <HconPubComDatepicker range v-model="dateRange" :resetPostion="resetPostion" placeholder="날짜" @updateDate="onDateUpdate" />
  </div>
</template>
<script lang="ts" setup>
import HconPubComDatepicker from '@/components/com/HconComPCDatepicker2.vue'
import { ref } from 'vue'

defineProps({
  label: {
    type: String,
    default: '검색일자'
  },
  labelClass: {
    type: String,
    default: ''
  },
  datePickerClass: {
    type: String,
    default: 'ml20'
  },
  resetPostion: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['update:startDate', 'update:endDate'])
const dateRange = ref<Date[] | [null, null]>([null, null])
const selectedMonth = ref<number | null>(null)
const isSelectedMonth = ref(false)

const toYYYYMMDD = (date: Date) => {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}${m}${d}`
}

// 1개월, 3개월.. 버튼 클릭 시
const setRange = (months: number) => {
  isSelectedMonth.value = true
  const today = new Date()
  const startDate = new Date()

  startDate.setMonth(today.getMonth() - months)
  dateRange.value = [startDate, today]

  emit('update:startDate', toYYYYMMDD(startDate))
  emit('update:endDate', toYYYYMMDD(today))
}

// 날짜 아이콘으로 직접 지정 시
const onDateUpdate = (val: string) => {
  if (!isSelectedMonth.value) {
    selectedMonth.value = null // 개월 선택 해제
  }
  isSelectedMonth.value = false
  const [start, end] = val.split(' ~ ')
  const toYYYYMMDD = (dateStr: string) => dateStr.replaceAll('.', '')
  
  emit('update:startDate', toYYYYMMDD(start))
  emit('update:endDate', toYYYYMMDD(end))
}

onMounted(() => {
  selectedMonth.value = 1
  setRange(1) // default : 1개월
  // nextTick(() => {
  //   isSelectedMonth.value = false
  // })
})

</script>
<style lang="scss" scoped>
@use '@/assets/scss/pc/common/variables-hcon.scss' as v;

.search-title {
  min-width: 110px;
  flex-basis: min-content;
  font-size: 15px;
  font-weight: 500;
}

.search-rdo-box {
  display: flex;
  border: 1px solid #999;
  border-radius: 8px;

  .search-rdo {
    width: 76px;
    height: 40px;
    display: flex;
    
    &:not(:last-child) {
      border-right: 1px solid #999;
    }

    &:first-child {
      label {
        border-radius: 8px 0 0 8px;
      }
    }

    &:last-child {
      label {
        border-radius: 0 8px 8px 0;
      }
    }

    label {
      display: inline-block;
      align-content: center;
      width: 100%;
      height: 100%;
      background-color: v.$white-color;
      text-align: center;
    }

    input[type="radio"] {
      position: absolute;
      opacity: 0;
      width: 76px;
      height: 40px;
      margin: 0;
      cursor: pointer;      

      &:checked {
        + label {
          outline: 1px solid v.$primary-color;
          color: v.$primary-color;
          width: 100%;
          height: 100%;
          align-content: center;
          text-align: center;

          &::after {
            outline: 1px solid v.$primary-color;
          }
        }
      }
    }
  }
}

.datepicker-wrap {
  width: 100%;
}

.popup-content {
  .search-rdo-box{
    .search-rdo {
      width: 66px;
      font-size: 14px;
    }
    input[type="radio"] {
      width: 66px;
    }
  }
}
</style>
